export default "__VITE_ASSET__CrnXt_aq__"